// TextField.jsx - Custom text input component matching Figma design
import React from 'react';

const TextField = ({
  label,
  type = 'text',
  value,
  onChange,
  error,
  placeholder,
  name,
  id,
  required = false,
  disabled = false,
  autoComplete,
  className = '',
  variant = 'dark',
  ...props
}) => {
  const inputId = id || name || label?.toLowerCase().replace(/\s+/g, '-');

  // The login screen renders on the white gradient (AuthLayout variant="light"),
  // where the dark fill and its near-white text would be unreadable.
  const isLight = variant === 'light';
  const surface = isLight
    ? 'bg-white text-[#282A29] placeholder-[#828382]'
    : 'bg-[#282a29] text-[#f0f5f2] placeholder-[#5d625f]';
  const idleBorder = isLight
    ? 'border-[#E8EBE9] focus:border-bloom-green focus:ring-bloom-green/40'
    : 'border-[#5d625f] focus:border-bloom-green focus:ring-bloom-green/40';

  return (
    <div className={`relative ${className}`}>
      <input
        type={type}
        id={inputId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder || label}
        required={required}
        disabled={disabled}
        autoComplete={autoComplete}
        aria-label={label}
        aria-invalid={error ? 'true' : 'false'}
        aria-describedby={error ? `${inputId}-error` : undefined}
        className={`w-full px-4 py-3 ${surface} border ${
          error
            ? 'border-red-500 focus:border-red-500 focus:ring-red-500/40'
            : idleBorder
        } rounded-[4px] text-[16px] font-['Inter'] focus:outline-none focus:ring-1 transition-colors disabled:opacity-50 disabled:cursor-not-allowed`}
        {...props}
      />
      {error && (
        <p
          id={`${inputId}-error`}
          className="mt-1 text-sm text-red-500 font-['Inter']"
          role="alert"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default TextField;
